
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRow from '@/components/atoms/TableRow.vue'
import TableHeader from '@/components/atoms/TableHeader.vue'
import TableData from '@/components/atoms/TableData.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import { ProofreadProblem } from '@/models/manage/ProofreadList'

/**
 * 校正機能-問題一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRow,
    TableHeader,
    TableData,
    LinkBase,
  },
})
export default class ProblemList extends Vue {
  /** 問題一覧 */
  @Prop()
  private problemList!: ProofreadProblem[]

  /** 問題選択時の処理 */
  @Prop()
  private eventSelectProblem!: (id: number) => Promise<void>
}
